import React from 'react';
import { formatDateKey, getCheckinTime, getLateColor, getSentence, getSessionIcon } from './utils';
import type { LateUserStatistics, UserStatistics, WorkSessionsByUser, WorkSessionsTableUser } from './types';

type Props = {
  user: WorkSessionsTableUser;
  dates: Array<Date>;
  workSessionsByUser: WorkSessionsByUser;
  statisticsByUser: Array<UserStatistics>;
  lateStatisticsByUser: Array<LateUserStatistics>;
};

const WorkSessionsTableRow = ({ user, dates, workSessionsByUser, statisticsByUser, lateStatisticsByUser }: Props): React.ReactElement => {
  const userStats = statisticsByUser.find(stat => stat.id === user.id);
  const totalOnSite = userStats ? userStats.onSiteCount : 0;
  const requiredSiteCount = userStats ? userStats.requiredSiteCount : 0;
  const lateUserStats = lateStatisticsByUser.find(stat => stat.id === user.id);
  const totalLate = lateUserStats ? lateUserStats.lateCount : 0;

  return (
    <tr>
      <td style={{ fontWeight: 'bold' }}>
        <div title={getSentence(totalOnSite)}>
          {user.name} {user.surname}
          <span style={{ marginLeft: '10px', fontSize: '10px', fontWeight: 'normal', color: '#6b7280', marginTop: '4px' }}>
             In office requirement:
             { requiredSiteCount >= 1 ? ' ✅' : ' ❌' }
          </span>
        </div>
        {totalLate == 0 ? '' : (
          <div style={{ marginLeft: '0px', fontSize: '10px', fontWeight: 'normal', color: '#6b7280', marginTop: '4px' }}>
            🕘 Late count in last 30 days: {totalLate}
          </div>
        )}
      </td>

      {dates.map(dateObj => {
        const dateString = formatDateKey(dateObj);
        const isWeekend = dateObj.getDay() === 0 || dateObj.getDay() === 6;

        if (isWeekend) {
          return <td key={dateString} className="day-column weekend" style={{ backgroundColor: '#f0f0f0' }}></td>;
        }

        const userSessions = workSessionsByUser[user.id] || [];
        const todaysSession = userSessions.find(session => session.date === dateString);

        return (
          <td
            key={dateString}
            className="day-column"
            style={{
              textAlign: 'center',
              backgroundColor: getLateColor(todaysSession)
            }}
          >
            {todaysSession ? (
              <>
                {getSessionIcon(todaysSession.sessionType)}
                {' '}{getCheckinTime(todaysSession.checkinTime)}{' '}
                <span style={{ fontSize: '0.85em', color: '#6b7280' }}>
                  ({todaysSession.sessionType.replace('_', ' ')})
                </span>
              </>
            ) : (
              '-'
            )}
          </td>
        );
      })}
    </tr>
  );
};

export default WorkSessionsTableRow;
